import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import Gallery from "../../components/gallery/Gallery";
import { websiteData } from "../../utils/data";

const PhotoGallery = () => {
  useEffect(() => {
    document.title = `Gallery | ${websiteData.company_name}`;
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Breadcrumbs title="Gallery" pagename="Gallery" />
      <section className="py-5" style={{ overflow: "hidden" }}>
        <Container>
          <Row>
            <Col>
              <Gallery />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PhotoGallery;
